import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppBootstrapModule } from './../app-bootstrap/app-bootstrap.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NavbarModule } from '../components/navbar/navbar.module';
import { SortByPipe } from './_pipes/sortBy.pipe';
import { BsDatepickerModule, DatepickerModule, BsDropdownModule } from 'ngx-bootstrap';
import { pipes } from './_pipes/index';
import { TagInputModule } from 'ngx-chips';
import { MentionModule, MentionDirective, MentionListComponent } from 'angular2-mentions/mention';
import { ColorPickerModule } from 'ngx-color-picker';
import { MyDatePickerModule } from 'mydatepicker';
import {DpDatePickerModule} from 'ng2-date-picker';
import {NgxPaginationModule} from 'ngx-pagination'; 

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "../assets/i18n/", ".json");
}

@NgModule({
  imports: [
    FormsModule,
    TagInputModule,
    ReactiveFormsModule,
    ColorPickerModule,
    MyDatePickerModule,
    NavbarModule,
    MentionModule,
    DpDatePickerModule,
    BsDropdownModule,
    NgxPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot()
  ],
  declarations: [
    SortByPipe, pipes  ],
  exports: [BsDatepickerModule, FormsModule, BsDropdownModule, DpDatePickerModule, MyDatePickerModule, MentionModule, MentionDirective, MentionListComponent, NgxPaginationModule, TagInputModule, TranslateModule, ReactiveFormsModule, NavbarModule, ColorPickerModule, SortByPipe, pipes]
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts